import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { JobApplicationStatus } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationStatusService extends BaseService<JobApplicationStatus> {
  protected readonly documentPath = '/jobApplicationStatuses';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
